
import React from "react";
import { data } from "../data";
import {api} from "../api";
import avatar from '../assets/images/yo.jpeg';

const url_api = api +"/download";


export default function About() {
    
    return (

        <div className="about" >
            <img src={avatar} alt="yo" className="avatar" data-src={avatar} />

            <h1 className="fj"> { data.first_name } <span>{ data.last_name }</span></h1>

            <h4 className="titulo">{ data.job } </h4>

            <p className="bio">
                Soy un desarrollador con varios años de experiencia en la creación de aplicaciones web bajo el paradigma
                de la programación orientada a objetos; Haciendo uso de tecnologías como HTML, CSS, PHP, JavaScript, SQL y
                NoSQL,
                en el diseño y ejecución de proyectos dirigidos a una amplia variedad de usuarios.
            </p>

            <div className="about__a">
               
                <a target="_blank" className="btn btn-outline-info" href={"https://www.facebook.com/camquipctecni"} title="Facebook">
                    <i className="fa fa-facebook"></i></a>
                <a target="_blank" className="btn btn-outline-info" href={"https://twitter.com/fjcqdev"} title="Twitter">
                    <i className="fa fa-twitter"></i></a>
                <a target="_blank" className="btn btn-outline-info" href={"https://www.linkedin.com/in/franciscocamposq"}
                    title="Linkedin">
                    <i className="fa fa-linkedin"></i></a>
                <a target="_blank" className="btn btn-outline-info" href={"https://github.com/camquipc"} title="GitHub">
                    <i
                        className="fa fa-github"></i></a>
                <a target="_blank" className="btn btn-outline-info" href={url_api} title="Descargar CV">
                    <i className="fa fa-file-pdf-o"></i></a>
            </div>
            <a className="btn btn-outline-info parpadea go_down" href="#projects" title="Proyectos Recientes" >
              <i className="fa fa-arrow-down"></i>
            </a>
        </div>
    );
}   
